import React from 'react';
import { NodeViewContent, NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import AddHandle from './AddHandle';
import DragHandle from './DragHandle';
import BlockItemPlaceholder from './BlockItemPlaceholder';

const BlockItemComponent = (props: NodeViewProps) => {
  const { node } = props;

  const isEmpty =
    !node.content.childCount ||
    (node.content.childCount === 1 &&
      node.content.firstChild?.textContent === '');

  return (
    <NodeViewWrapper className="block-item">
      <AddHandle {...props} />
      <DragHandle {...props} />
      <NodeViewContent className="block-item-content" />
      {isEmpty && <BlockItemPlaceholder />}
    </NodeViewWrapper>
  );
};

export default BlockItemComponent;
